/**
 * The `markScope` mark on `SpCheckout`. Checkout stores bound to it give every checkout on a page
 * its own state, even when several sit inside one outer custom element.
 */
export const CHECKOUT_SCOPE = Symbol("checkout");
